export const timePickerStyles = {
  timePicker: {
    width: '100%',
    '& input, & label': {
      fontFamily: 'Rubik, sans-serif',
    },
    '& input': {
      fontSize: '14px',
      color: '#354052',
    },
    '& .MuiInput-underline': {
      height: '29px',
      '&:before': {
        borderBottomColor: 'rgb(197, 208, 222)',
      },
      '&:after': {
        borderBottomColor: 'rgb(32, 112, 173)',
      },
    },
    '& .MuiFormLabel-root': {
      color: '#7f8fa4',
      '&.Mui-focused': {
        color: '#7f8fa4',
      },
    },
  },
};
